module.exports = __webpack_public_path__ + "media/images/emails/pinterest-cfbee8e3291a723946bd01546473e4df.png";